/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_Create_StudentInputs */

const en_capture_create_student = /** @type {(inputs: Capture_Create_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create student`)
};

const he_capture_create_student = /** @type {(inputs: Capture_Create_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת תלמיד`)
};

/**
* | output |
* | --- |
* | "Create student" |
*
* @param {Capture_Create_StudentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_create_student = /** @type {((inputs?: Capture_Create_StudentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_Create_StudentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_create_student(inputs)
	return he_capture_create_student(inputs)
});